/**
 * Action for Create new Service
 */
export enum createService {
  CREATE_SERVICE = 'CREATE_SERVICE',
  CLEAR_SERVICE_DETAILS = 'CLEAR_SERVICE_DETAILS'
}

/**
 * Action for Create new Service
 */

export enum updateService {
  UPDATE_SERVICE = 'UPDATE_SERVICE',
  CLEAR_UPDATE_SERVICE_DETAILS = 'CLEAR_UPDATE_SERVICE_DETAILS'
}

/**
 * Action for Fetch Event
 */
export enum getServiceType {
  FETCH_SERVICE_REQUEST = 'FETCH_SERVICE_REQUEST'
}

/**
 * Action for Fetch Event
 */
export enum getAllServices {
  FETCH_ALL_SERVICE_REQUEST = 'FETCH_ALL_SERVICE_REQUEST'
}

export enum getExceptionList {
  FETCH_EXCEPTION_REQUEST = 'FETCH_EXCEPTION_REQUEST'
}
export enum getAllExceptionList {
  FETCH_ALL_EXCEPTION_LIST_REQUEST = 'FETCH_ALL_EXCEPTION_LIST_REQUEST'
}

export enum createNewException {
  CREATE_NEW_EXCEPTION_REQUEST = 'CREATE_NEW_EXCEPTION_REQUEST'
}

export enum getException {
  GET_EXCEPTION_REQUEST = 'GET_EXCEPTION_REQUEST'
}

export enum getServiceExceptionList {
  FETCH_SERVICE_EXCEPTION_LIST_REQUEST = 'FETCH_SERVICE_EXCEPTION_LIST_REQUEST'
}
